import { App, Plan } from '@back4app2/sdk';

/**
 * The paid plan a free choice turns into when a paid-only option is picked —
 * and the one an Upgrade from Free buys straight away.
 *
 * Its own module: the creation flow and the app shell both need it, and
 * neither should import the other for one sort.
 */
export const cheapestPaidPlan = (plans: Plan[]): Plan | undefined =>
  plans
    .filter((plan) => plan.price > 0)
    .sort((a, b) => a.price - b.price)[0];

/**
 * Whether the app runs on the Free plan — the same '%Free%' test the domain
 * sweeper and `triggerManualDeployment` run on the server.
 */
export const isFreePlanApp = (app: App): boolean =>
  !!app.mainService?.mainServiceEnvironment?.plan?.name?.includes('Free');
